































































import { computed, defineComponent, PropType, ref } from '@vue/composition-api';
import {
  IWorkflowState,
  IWorkflowStateThreshold,
  IWorkflowStateThresholdGroup,
  IWorkflowStateThresholdGroupData
} from '@/models';
import { getPropertyFromItem } from '@/utils/helpers';
import { useFetchThresholdGroups } from '@/composable/useWorkflowStateThresholdGroup';
import { useFetchThresholds } from '@/composable/useWorkflowStateThreshold';

import auth from '@/mixins/auth';

import AlTooltipBtn from '../common/AlTooltipBtn.vue';
import DetailOptionsButton from '../common/DetailOptionsButton.vue';
import ErrorAlert from '../common/ErrorAlert.vue';
import WorkflowStateThresholdFormDialog from './WorkflowStateThresholdFormDialog.vue';
import WorkflowStateThresholdDetail from './WorkflowStateThresholdDetail.vue';
import WorkflowStateThresholdGroupFormDialog from './WorkflowStateThresholdGroupFormDialog.vue';
import WorkflowStateThresholdsGroupDetail from './WorkflowStateThresholdsGroupDetail.vue';

export default defineComponent({
  name: 'WorkflowStateThresholdsGroupList',

  components: {
    AlTooltipBtn,
    DetailOptionsButton,
    ErrorAlert,
    WorkflowStateThresholdDetail,
    WorkflowStateThresholdFormDialog,
    WorkflowStateThresholdGroupFormDialog,
    WorkflowStateThresholdsGroupDetail
  },

  props: {
    workflowState: {
      type: Object as PropType<IWorkflowState>,
      required: true
    },
    workflowId: { type: Number, required: true },
    disabled: {
      type: Boolean
    }
  },

  mixins: [auth],

  setup(props) {
    const {
      thresholdGroups,
      isLoadingThresholdGroups,
      thresholdGroupsError
    } = useFetchThresholdGroups(props.workflowId, props.workflowState.id!);
    const {
      thresholds,
      isLoadingThresholds,
      thresholdsError
    } = useFetchThresholds(props.workflowId, props.workflowState.id!);

    function filteredThresholds(group: IWorkflowStateThresholdGroup) {
      return thresholds.value.filter(
        (t: IWorkflowStateThreshold) =>
          t.threshold_group &&
          getPropertyFromItem(t.threshold_group, 'id', t.threshold_group) ===
            group.id
      );
    }

    const isEdit = ref(false);

    // For threshold group dialog
    const isGroupDialogActive = ref(false);
    const selectedThresholdGroup = ref<IWorkflowStateThresholdGroupData | null>(
      null
    );

    function openCreateThresholdGroupDialog() {
      isEdit.value = false;

      selectedThresholdGroup.value = null;
      isGroupDialogActive.value = true;
    }

    function openEditThresholdGroupDialog(group: IWorkflowStateThresholdGroup) {
      isEdit.value = true;

      selectedThresholdGroup.value = group;
      isGroupDialogActive.value = true;
    }

    const error = computed(() => {
      return thresholdGroupsError.value || thresholdsError.value;
    });

    return {
      error,
      isEdit,
      isLoadingThresholdGroups,
      selectedThresholdGroup,
      isGroupDialogActive,
      openCreateThresholdGroupDialog,
      openEditThresholdGroupDialog,
      thresholdGroups,
      filteredThresholds,
      isLoadingThresholds,
      thresholdsError
    };
  }
});
